import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { MembershipPage } from './pages/MembershipPage';
import { EventsPage } from './pages/EventsPage';
import { CharityPage } from './pages/CharityPage';
import { TeamPage } from './pages/TeamPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  return <HelmetProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Layout data-id="element-5" />} data-id="element-4">
              <Route index element={<HomePage data-id="element-7" />} data-id="element-6" />
              <Route path="about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
              <Route path="membership" element={<MembershipPage data-id="element-11" />} data-id="element-10" />
              <Route path="events" element={<EventsPage data-id="element-13" />} data-id="element-12" />
              <Route path="charity" element={<CharityPage data-id="element-15" />} data-id="element-14" />
              <Route path="team" element={<TeamPage data-id="element-17" />} data-id="element-16" />
              <Route path="contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
              <Route path="privacy" element={<PrivacyPolicyPage data-id="element-21" />} data-id="element-20" />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>;
}